import React from 'react';
import { useMediaQuery } from '@mui/material';
import theme from '@src/styles/theme';
import { StyledProjectDetail } from '../index.style';
import Content from './Content';
import ProjectOnMobile from '../../Project/ProjectOnMobile';
import Header from '../component/ProjectDetailHeader';

const TTSDetail = () => {
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

  if (isMobile) {
    return (
      <div style={{ padding: '0 16px' }}>
        <ProjectOnMobile />
      </div>
    );
  }

  return (
    <StyledProjectDetail>
      <div className="container-main-panel">
        <Header />
        <Content />
      </div>
    </StyledProjectDetail>
  );
};

export default TTSDetail;
